import sensors from 'sa-sdk-javascript'
import publickFn from './publicFn'

let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
let env = window.location.port ? 'testing3' : 'prod';
envArr.forEach(d => {
  if (window.location.hostname.includes(d)) {env = d}
})
let project = 'default'
if (process.env.NODE_ENV === 'production' && env === 'prod') {
	project = 'production'
}

// let saas_id = '166'
// if(env === 'fat'){
//     saas_id = '174'
// }else if(env === 'uat'){
//     saas_id = '146'
// }

// console.log('env----',env)
// console.log('hanmeng ----', localStorage.getItem('is_track_single_page'))

let is_track_single_page = localStorage.getItem('is_track_single_page')
is_track_single_page == 'true' ? is_track_single_page = true : is_track_single_page = false
sensors.init({
	server_url: `https://sc-datasink.wdeduc.com/sa?project=${project}`,
	is_track_single_page,
	show_log: false,
	app_js_bridge: true,
	heatmap: {
		clickmap: is_track_single_page ? 'default' : 'not_collect',
		scroll_notice_map: is_track_single_page ? 'default' : 'not_collect',
		get_vtrack_config:true
	},
})

let platform = publickFn.getUserAgent()
console.log('sensors-------platform', platform)
let mktSourceName = ''
let productName = '伟东云'

if(publickFn.getQueryVariable('mkt_source_name') === 'lekecheng'){
  mktSourceName =  '乐客城公众号';
}else if(publickFn.getQueryVariable('mktSourceName') === 'weidongyun'){
  mktSourceName = '伟东云公众号';
}else if(publickFn.getQueryVariable('mktSourceName') === '619personalShare'){
	mktSourceName = '父亲节个人分享';
}else {
  mktSourceName = '非公众号';
}

if(window.location.pathname === '/51activitie'){
	productName = '乐客城51活动'
}else if(window.location.pathname === '/weidongActivity'){
	productName = '伟东51活动'
}else if(window.location.pathname === '/activityCounty'){
	productName = '三年千县百亿活动'
}else if (window.location.pathname === '/619-Activity'){
	productName = '父亲节活动'
}else if (window.location.pathname === '/grouppurchase/activity'){
	mktSourceName = '818活动'
	productName = '818活动'
}else if (window.location.pathname === '/seckill/activity'){
	mktSourceName = '921活动'
	productName = '921活动'
}

export const sensorsCommonProperty  = {
	platform_type: 'H5',
	saas_id: localStorage.getItem('saasId'),
	saas_name: localStorage.getItem('saasName') || '伟东云职业教育生态平台',
  mkt_source_name:mktSourceName,
	product_name:productName,
  institution_id: localStorage.getItem('branchId'),
	// institution_id: function () {
	// 	// 所属机构ID
	// 	const c_branchUcode = localStorage.getItem('c_branchUcode')
	// 	const userInfo = localStorage.getItem('userInfo')
	// 	let institution_id = userInfo && JSON.parse(userInfo).institution_id
	// 	if (platform === 'h5' || platform === 'wechat') {
	// 		return c_branchUcode || ''
	// 	} else {
	// 		return institution_id || ''
	// 	}
	// },
	institution_name: function () {
		// 所属机构名称
		const c_branchName = localStorage.getItem('c_branchName')
		const userInfo = localStorage.getItem('userInfo')
        let institution_name = userInfo && JSON.parse(userInfo).institution_name
        
		if (platform === 'h5' || platform === 'wechat') {
			return c_branchName || ''
		} else {
			return institution_name || ''
		}
	},
	current_identity: function () {
		// 用户身份
		const identity = localStorage.getItem('identity')
		const userInfo = localStorage.getItem('userInfo')
        let current_identity = userInfo && JSON.parse(userInfo).current_identity
        
		if (platform === 'h5' || platform === 'wechat') {
			return identity || ''
		} else {
			return current_identity || ''
		}
	},
	is_login: function () {
		// 是否登录
		const h5token = localStorage.getItem('token')
		const userInfo = localStorage.getItem('userInfo')
        let token = userInfo && JSON.parse(userInfo).token
        
		if (platform === 'h5' || platform === 'wechat') {
			return h5token ? 1 : 0
		} else {
			return token ? 1 : 0
		}
	},
};

sensors.registerPage(sensorsCommonProperty);

is_track_single_page && sensors.quick('autoTrack') // 首次触发页面加载事件 $pageview

export default sensors
// 自定义事件埋点
// this.$sensors.track('ViewSupplyChainDetails'[, param][,callback])
